module.exports = __webpack_public_path__ + "img/Weapon_182.2434609e.png";